(() => {
  const revealSelector = '[data-bos-reveal]';

  const setReveal = (elements, step = 0.08, offset = 0) => {
    elements.forEach((element, index) => {
      if (element.dataset.bosRevealBound === 'true') return;
      element.dataset.bosReveal = 'true';
      element.dataset.bosRevealBound = 'true';
      element.style.setProperty('--bos-delay', `${offset + index * step}s`);
    });
  };

  const bindRevealTargets = (root = document) => {
    setReveal(Array.from(root.querySelectorAll('.bos-hero__title')), 0, 0.05);
    setReveal(Array.from(root.querySelectorAll('.bos-hero__content .bos-home__buttons')), 0, 0.18);
    setReveal(Array.from(root.querySelectorAll('.bos-hero__product')), 0, 0.28);
    setReveal(Array.from(root.querySelectorAll('.bos-collection-hero__content > *')), 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-collection-hero__media')), 0, 0.18);
    setReveal(Array.from(root.querySelectorAll('.bos-collection-grid__header > *')), 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-collection-grid__filters')), 0, 0.06);
    setReveal(Array.from(root.querySelectorAll('.bos-product-card')), 0.06);
    setReveal(Array.from(root.querySelectorAll('.bos-product-hero__content > *')), 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-product-hero__media')), 0, 0.14);
    setReveal(Array.from(root.querySelectorAll('.bos-product-feature-grid__heading > *')), 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-product-feature-grid__card')), 0.08, 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-product-media-banner__content > *')), 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-product-split__copy > *')), 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-product-split__media')), 0, 0.12);
    setReveal(Array.from(root.querySelectorAll('.bos-product-split__metric')), 0.06, 0.14);

    root.querySelectorAll('.bos-featured-product__slide').forEach((slide) => {
      setReveal(Array.from(slide.children), 0.1);
    });

    setReveal(Array.from(root.querySelectorAll('.bos-home__heading')), 0.06);
    setReveal(Array.from(root.querySelectorAll('.bos-scenario-card')), 0.1);
    setReveal(Array.from(root.querySelectorAll('.bos-highlights__primary')), 0, 0.04);
    setReveal(Array.from(root.querySelectorAll('.bos-highlights__grid .bos-card')), 0.08, 0.1);
    setReveal(Array.from(root.querySelectorAll('.bos-tech__primary')), 0, 0.04);
    setReveal(Array.from(root.querySelectorAll('.bos-tech__card')), 0.08, 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-compare-card')), 0.1);
    setReveal(Array.from(root.querySelectorAll('.bos-testimonial-card')), 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-video-card')), 0.08);
    setReveal(Array.from(root.querySelectorAll('.bos-trust__item')), 0.06);
    setReveal(Array.from(root.querySelectorAll('.bos-cta__content > *')), 0.08);
  };

  const revealElements = (root = document) => {
    const nodes = Array.from(root.querySelectorAll(revealSelector)).filter(
      (node) => node.dataset.bosRevealObserved !== 'true'
    );

    if (!nodes.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      nodes.forEach((node) => {
        node.dataset.bosRevealObserved = 'true';
        node.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    nodes.forEach((node) => {
      node.dataset.bosRevealObserved = 'true';
      observer.observe(node);
    });
  };

  const initBosMotion = (root = document) => {
    document.documentElement.classList.add('bos-motion-ready');
    bindRevealTargets(root);
    revealElements(root);
  };

  document.addEventListener('DOMContentLoaded', () => initBosMotion(document));
  document.addEventListener('shopify:section:load', (event) => initBosMotion(event.target));
})();
